document.addEventListener('DOMContentLoaded', function () {
  var ripple = document.getElementById('zd-ripple');
  if (ripple) {
    var root = document.documentElement;
    window.addEventListener(
      'pointermove',
      function (e) {
        root.style.setProperty('--cursor-x', e.clientX + 'px');
        root.style.setProperty('--cursor-y', e.clientY + 'px');
      },
      { passive: true }
    );
  }

  document.querySelectorAll('[data-zd-product-section]').forEach(initProductSection);
});

function initProductSection(section) {
  var form = section.querySelector('[data-zd-product-form]');
  var variantsEl =
    section.querySelector('[data-zd-product-variants]') ||
    (section.nextElementSibling &&
    section.nextElementSibling.matches &&
    section.nextElementSibling.matches('[data-zd-product-variants]')
      ? section.nextElementSibling
      : null) ||
    document.querySelector('[data-zd-product-variants]');
  if (!form || !variantsEl) return;

  var variants;
  try {
    variants = JSON.parse(variantsEl.textContent);
  } catch (e) {
    return;
  }
  if (!variants.length) return;

  var idInput = form.querySelector('[data-zd-variant-id]');
  var priceEl = section.querySelector('[data-zd-product-price]');
  var addBtn = form.querySelector('[data-zd-add-to-cart]');
  var optionSelects = Array.prototype.slice.call(form.querySelectorAll('[data-zd-option]'));
  var addLabel =
    (addBtn && addBtn.dataset.zdAddLabel) ||
    (addBtn ? addBtn.textContent.trim() : 'Add to cart');
  var soldOutLabel = (addBtn && addBtn.dataset.zdSoldOutLabel) || 'Sold out';

  if (addBtn && addBtn.disabled && !addBtn.dataset.zdSoldOutLabel) {
    soldOutLabel = addBtn.textContent.trim();
  }

  function findVariant() {
    if (!optionSelects.length) return variants[0];
    var selected = optionSelects.map(function (sel) {
      return sel.value;
    });
    return variants.find(function (variant) {
      return variant.options.every(function (opt, i) {
        return opt === selected[i];
      });
    });
  }

  function syncVariantInput(variant) {
    if (!variant) return false;
    var variantId = String(variant.id);
    var variantInputs = Array.prototype.slice.call(form.querySelectorAll('input[name="id"]'));

    if (idInput && variantInputs.indexOf(idInput) === -1) {
      variantInputs.push(idInput);
    }

    variantInputs.forEach(function (input) {
      input.value = variantId;
      input.setAttribute('value', variantId);
    });
    form.dataset.zdVariantId = variantId;
    return true;
  }

  function updateVariant() {
    var variant = findVariant();
    if (!variant) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = soldOutLabel;
      }
      return null;
    }
    syncVariantInput(variant);
    if (priceEl) priceEl.textContent = variant.priceFormatted;
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? addLabel : soldOutLabel;
    }
    return variant;
  }

  optionSelects.forEach(function (sel) {
    sel.addEventListener('change', updateVariant);
  });
  form.addEventListener('submit', function (event) {
    var variant = updateVariant();
    if (!variant || !variant.available) {
      event.preventDefault();
    }
  });
  updateVariant();
}
